import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";

interface TableColumnMoveCompleteEvent2 {
    (sender: CustomTable2, userResized: boolean): void;
}

class ColumnWidthInfo {
    public IsFixed: boolean;
    public value: number;
    public id: string;
}

class CustomTable2 {
    private containerId: string;
    private headerTb: JQuery;
    private bodyTb: JQuery;
    private mainContainer: JQuery;
    private colWidthBuffer: ColumnWidthInfo[];
    private options: ITableRenderOptions;
    private resizeDelegate: TableColumnMoveCompleteEvent2;
    private posrefClassName: string;

    /* misc stuff */
    private movingColumn: JQuery;
    private nextColumn: JQuery;

    /* performance tuning.. set on mouse click */
    /* colgroup > col */
    private headerColGp: HTMLElement;
    private headerNextColGp: HTMLElement;

    /* colgroup > col */
    private bodyColGp: HTMLElement;
    private bodyNextColGp: HTMLElement;
    /* end */

    private initialPosition: number;
    private initialColumnWidth: number;
    private initialWidthOfNextColumn: number;
    private movingColumnIndex: number;
    private moveFlag: boolean;
    private currentContainerWidth: number;
    private minColWidth: number; // (redundency for performance reasons..)

    private resizeTimeoutReference: number;

    constructor(containerId: string, opt: ITableRenderOptions, onColumnsResizedDelegate?: TableColumnMoveCompleteEvent2, posRefClassName?: string) {
        var self = this;
        this.containerId = containerId;
        this.posrefClassName = (IsNullOrWhiteSpace(posRefClassName)) ? "posref" : posRefClassName;

        this.options = opt;

        if (this.options.get("HeightOffset") == null) {
            this.options = this.options.set("HeightOffset", 60);
        }

        this.resizeDelegate = onColumnsResizedDelegate;
        this.initializeJqueryElements();
        var containerWidth = this.containerWidth();
        this.minColWidth = opt.get("MinColWidth");

        this.bindInitialEvents(opt);

        var columns = opt.get("Cols").toArray();

        var columnsInitialState = this.initializeColumItentityAndWidth(columns);

        columnsInitialState = this.getColumnWidthArray(columnsInitialState, containerWidth); // this will "condition" our columns

        this.initializeTableColumns(columnsInitialState);

        this.colWidthBuffer = columnsInitialState;

        this.setMaxHeight();

        this.mainContainer.css("visibility", "visible");

        $(window).on("resize.calevent", () => self.debouncedSetMaxHeight(self));
    }

    private initializeColumItentityAndWidth(cols: number[]): ColumnWidthInfo[] {
        var r = [];
        this.headerTb.find("th").each((idx, rawElement) => {
            var col = new ColumnWidthInfo();
            var elem = $(rawElement);
            var sw = +elem.attr("data-sw");
            if (isNaN(sw)) {
                col.IsFixed = false;
                col.value = cols[idx]; // passing relative %
            }
            else {
                col.IsFixed = true;
                col.value = sw; // passing fixed pixel value
            }
            col.id = elem.attr("data-header");
            r.push(col);
        });
        return r;
    }

    private getColumnWidthArray(a: ColumnWidthInfo[], containerWidth: number): ColumnWidthInfo[] {
        var cls = [];

        var r = this.getArrayWithStaticWidthConvertedToRelativeWidth(a, containerWidth);

        var t = this.getArrayReduction(r);

        var filteredOutFixedColumns = a.filter(e => e.IsFixed === false);

        var maxValue = this.getMaxValueInArray(this.getArrayWithStaticWidthConvertedToRelativeWidth(filteredOutFixedColumns, containerWidth));
        if (t >= 100) {
            cls = this.paddColumnsReduce(a, t, maxValue);
        }
        else if (t < 100) {
            cls = this.paddColumnsIncrease(a, t, maxValue);
        }
        return cls;
    }

    private paddColumnsReduce(a: ColumnWidthInfo[], totalWidthReduction: number, maxValue: number): ColumnWidthInfo[] {
        var delta = totalWidthReduction - 100; // percentages..
        var result = [];
        var adjusted = false;
        for (let column of a) {
            if (!adjusted && maxValue === column.value && !column.IsFixed) {
                var c = new ColumnWidthInfo();
                c.id = column.id;
                c.IsFixed = column.IsFixed;
                c.value = column.value - delta;
                result.push(c);
                adjusted = true;
            }
            else {
                result.push(column);
            }
        }
        return result;
    }

    private paddColumnsIncrease(a: ColumnWidthInfo[], totalWidthReduction: number, maxValue: number): ColumnWidthInfo[] {
        var delta = 100 - totalWidthReduction; // percentages..
        var result = [];
        var adjusted = false;
        for (let column of a) {
            if (!adjusted && maxValue === column.value && !column.IsFixed) {
                var c = new ColumnWidthInfo();
                c.id = column.id;
                c.IsFixed = column.IsFixed;
                c.value = column.value + delta;
                result.push(c);
                adjusted = true;
            }
            else {
                result.push(column);
            }
        }

        return result;
    }

    private getMaxValueInArray(a: number[]): number {
        return Math.max.apply(Math, a);
    }

    private getArrayReduction(a: number[]): number {
        if (a && a.length > 0) {
            return a.reduce((x, y) => x + y);
        }
        else {
            return null;
        }
    }

    private getArrayWithStaticWidthConvertedToRelativeWidth(a: ColumnWidthInfo[], width: number): number[] {
        var r = [];
        for (let column of a) {
            if (column.IsFixed) {
                var pr = (column.value / width) * 100;
                r.push(pr);
            }
            else {
                r.push(column.value);
            }
        }
        return r;
    }

    private containerWidth(): number {
        return this.mainContainer.width();
    }

    private initializeJqueryElements(): void {
        this.mainContainer = $("#" + this.containerId);
        this.headerTb = $(this.mainContainer).find("div.header table");
        this.bodyTb = $(this.mainContainer).find("div.content table");
    }

    private bindInitialEvents(opt: ITableRenderOptions): void {
        const table = this;
        this.headerTb.find("th").each(function(i: number, cell: Element) {
            $(this).attr("data-idx", i);
            if (opt.get("FirstColumnNoDrag") && i === 0)
                return true;

            $(this).find("span.handle").remove();

            const handle = document.createElement("span");
            handle.setAttribute("class", "handle dot");
            handle.style.height = (cell.clientHeight - 3) + "px";

            $(handle).on("mousedown.mbt", e => table.onMouseDown(e, table));
            $(handle).on("touchstart.mbt", e => table.onMouseDown(e, table));
            $(this).prepend(handle);
        });
    }

    private initializeTableColumns(cols: ColumnWidthInfo[]): void {
        var colgroups = "<colgroup>";
        this.headerTb.find("colgroup").remove();
        this.bodyTb.find("colgroup").remove();
        this.headerTb.find("th").each((index: number) => {
            // $(this).css("width", cols[index] + "%");

            if (cols[index].IsFixed) {
                colgroups += `<col data-id="${cols[index].id}" data-sw="${cols[index].value}" style="width:${cols[index].value}px" />`;
            }
            else {
                colgroups += `<col data-id="${cols[index].id}" data-w="${cols[index].value}" style="width:${cols[index].value}%" />`;
            }
        });
        colgroups += "</colgroup>";
        this.headerTb.prepend(colgroups);
        this.bodyTb.prepend(colgroups);
    }

    private setMaxHeight(): void {
        // scroll-limit
        var limitElement = this.mainContainer.find(".scroll-limit");
        if (limitElement.length === 0)
            return;

        var h = 0;
        var elem = $(limitElement).closest(".fxheight, .fxheightpopup");
        if (elem.hasClass("fxheightpopup")) {
            elem = $(elem).closest(".popup-with-grid");
        }

        if (elem.length === 0) {
            elem = $("#" + this.posrefClassName);
            if (elem.css("max-height"))
                h = +elem.css("max-height").replace("px", "") - 42;
        }
        else {
            var delta = limitElement.offset().top - elem.offset().top;
            h = +elem.css("height").replace("px", "");
            h = h - delta - this.options.get("HeightOffset");
        }
        // limitElement.css("height", (h - this.headerTb.height()) + "px");
        limitElement.css("height", h + "px");
    }

    private debouncedSetMaxHeight(context: CustomTable2): void {
        if (context.resizeTimeoutReference != null) {
            clearTimeout(context.resizeTimeoutReference);
            context.resizeTimeoutReference = null;
        }
        context.resizeTimeoutReference = window.setTimeout(
            () => context.setMaxHeight(),
            50
        );
    }

    private onMouseDown(e: JQueryEventObject, context: CustomTable2): void {
        context.currentContainerWidth = context.containerWidth(); // register current width
        context.pauseEvent(e);
        context.moveFlag = false;
        var p = context.getPageXFromEvent(e);
        context.initialPosition = p;

        // bind next events
        $(document).on("mousemove.mbt", e => context.onMouseMove(e, context));
        $(document).on("mouseup.mbt", e => context.onMouseUp(e, context));
        $(document).on("touchmove.mbt", e => context.onMouseMove(e, context));
        $(document).on("touchend.mbt", e => context.onMouseUp(e, context));
        var sender = e.srcElement;
        if (!sender) sender = e.target;

        // register moving column
        context.movingColumn = $(sender).closest("th");
        $(sender).addClass("hover-active");
        context.movingColumnIndex = +$(context.movingColumn).attr("data-idx");
        context.nextColumn = context.findNextColumn(context.movingColumn, context);

        context.initialColumnWidth = context.movingColumn.get(0).offsetWidth - 1;
        context.initialWidthOfNextColumn = context.nextColumn.get(0).offsetWidth - 1;

        /* set moving colgroups */
        var _h = context.headerTb.find("colgroup col");
        var _b = context.bodyTb.find("colgroup col");
        context.headerColGp = _h.get(context.movingColumnIndex);
        context.headerNextColGp = _h.get(context.movingColumnIndex + 1);
        context.bodyColGp = _b.get(context.movingColumnIndex);
        context.bodyNextColGp = _b.get(context.movingColumnIndex + 1);
    }

    // calls calculate function
    private onMouseMove(e: JQueryEventObject, context: CustomTable2): void {
        context.pauseEvent(e);
        context.calculate(e, context);
    }

    private calculate(e: JQueryEventObject, context: CustomTable2): void {
        var a = context.initialPosition;
        var b = context.getPageXFromEvent(e);
        var delta = a - b;
        if (delta == 0)
            return;
        context.moveFlag = true; // we moved

        var w = context.initialColumnWidth - delta; // new pixesl
        var p = (w / context.currentContainerWidth) * 100;

        var nw = context.initialWidthOfNextColumn + (delta + 2);// 2 is a static adjuster that just works :/
        var np = (nw / context.currentContainerWidth) * 100;

        if (w > context.minColWidth && nw > context.minColWidth) {
            context.moveHeaderColumns(context.headerColGp, p);
            context.moveHeaderColumns(context.headerNextColGp, np);

            context.moveHeaderColumns(context.bodyColGp, p);
            context.moveHeaderColumns(context.bodyNextColGp, np);
        }
        else {
            console.log("limit ");
        }
    }

    private onMouseUp(e: JQueryEventObject, context: CustomTable2): void {
        context.pauseEvent(e);

        // unbind events
        $(document).off("mousemove.mbt");
        $(document).off("mouseup.mbt");
        $(document).off("touchmove.mbt");
        $(document).off("touchend.mbt");

        if (context.moveFlag) {
            // upadate ratio buffer
            context.colWidthBuffer.length = 0; // flush

            context.headerTb.find("colgroup col").each(function() {
                var num = +$(this).attr("data-w");
                var numf = +$(this).attr("data-sw");

                var ci = new ColumnWidthInfo();
                ci.id = $(this).attr("data-id");
                if (isNaN(numf)) {
                    ci.IsFixed = false;
                    ci.value = num;
                }
                else {
                    ci.IsFixed = true;
                    ci.value = numf;
                }
                context.colWidthBuffer.push(ci);
            });

            // call delegate function to report columns changed
            if (context.resizeDelegate != null && context.options.get("QuietlyResize") !== true) {
                context.resizeDelegate.apply(context, [context, true]);
            }
        }

        $(context.headerTb).find("th span.hover-active").each(function() { $(this).removeClass("hover-active"); });
        context.movingColumn = null;
        context.movingColumnIndex = -1;

        context.headerColGp = null;
        context.headerNextColGp = null;
        context.bodyColGp = null;
        context.bodyNextColGp = null;
    }

    private pauseEvent(e: JQueryEventObject): boolean {
        if (e.stopPropagation)
            e.stopPropagation();

        if (e.preventDefault)
            e.preventDefault();

        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }

    private getPageXFromEvent(e: JQueryEventObject): number {
        if (isNaN(e.pageX) && e.originalEvent instanceof TouchEvent)
            return e.originalEvent.touches[0].pageX;
        else
            return e.pageX;
    }

    private moveHeaderColumns(movingColumn: HTMLElement, width: number): void {
        $(movingColumn).attr("data-w", width).width(width + "%");
    }

    private findNextColumn(currentColumn: JQuery, context: CustomTable2): JQuery {
        var index = +$(currentColumn).attr("data-idx"); index++;
        return $(context.headerTb).find(`th[data-idx="${index}"]`).first();
    }

    public getColumnRatios(): KeyValuePair<string, number>[] {
        return this.colWidthBuffer
            .map(i => new KeyValuePair(i.id, i.value));
    }

    public destroy(): void {
        this.headerTb.find("th").each(function() {
            $(this).off("mousedown.mbt");
            $(this).off("touchstart.mbt");
        });

        this.headerTb.find("span.handle").remove();
        this.headerTb.find("th").each(function() { $(this).removeAttr("data-idx"); });
        $(window).off("resize.calevent");
    }
}

export { CustomTable2 };
